import * as React from 'react';
import { SVGProps } from 'react';

interface ChallengeIconProps extends React.SVGProps<SVGSVGElement> {
  fillHandColor?: string;
  fillArmColor?: string;
}

const ThumbsUpIcon = ({
  fillHandColor = 'none',
  fillArmColor = 'none',
  ...props
}: ChallengeIconProps): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 41"
    fill="none"
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path
        className="thumb-arm"
        fill={fillArmColor}
        d="M11.487 32.08H8.364a1.747 1.747 0 0 1-1.747-1.748v-12.22c0-.965.783-1.748 1.747-1.748h3.123c.965 0 1.747.783 1.747 1.747v12.221c0 .965-.782 1.747-1.747 1.747Z"
      />
      <path
        className="thumb-hand"
        fill={fillHandColor}
        d="m14 18 5.27-7.721a2.868 2.868 0 0 1 4.49-.076c.438.53.677 1.199.677 1.887v5.411h5.121c.994 0 1.922.496 2.475 1.322l.544.812c.488.73.63 1.638.387 2.48l-2.248 7.81a2.977 2.977 0 0 1-2.86 2.155H17.453a2.976 2.976 0 0 1-2.18-.95L14 29.5"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 .65h39.701v39.7H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default ThumbsUpIcon;
